import useWalletStore from '@/lib/store/useWalletStore'
import LangModule from '../Lang'
import MenuModule from '../Menu'

import { ReactComponent as LOGO } from '@/assets/svg/logo-max.svg'

export default function TopBarModule() {
	const isSign = useWalletStore(state => state.isSign)
	return (
		<div
			className={`relative ${isSign ? '' : 'z-50'} flex h-14 items-center justify-between border-b border-[#454545] px-3 py-4`}
		>
			<MenuModule />
			<LOGO />
			<LangModule />
		</div>
	)
}
